import classNames from 'classnames'
import kebabCase from 'lodash.kebabcase'
import React from 'react'
import { Text } from '../../elements/Text'
import { IHeaderNavigationLinkBadge } from './index'

export function HeaderNavigationLinkBadge({
  text,
  color = 'lightTeal',
}: IHeaderNavigationLinkBadge): React.ReactElement {
  const badgeClassName = classNames('badge', {
    [`mvp-background-color-${kebabCase(color)}`]: color,
  })
  return (
    <>
      <span className={badgeClassName} data-testid="header-navigation-link-badge">
        <Text size="eyebrow">{text}</Text>
      </span>
      <style jsx>{`
        .badge {
          display: flex;
          align-items: center;
          border-radius: 14px;
          padding: 0.125rem 0.5rem;
          margin-left: 7px;

          :global(span) {
            font-size: 12px;
            color: var(--mvp-blue);
          }
        }
      `}</style>
    </>
  )
}
